//  ----------------------------------------------------------------------
//  Authentication
//  ----------------------------------------------------------------------
export const AUTH_GUEST = 'AUTH_GUEST';
export const AUTH_USER = 'AUTH_USER';
export const UNAUTH_USER = 'UNAUTH_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const PROTECTED_TEST = 'PROTECTED_TEST';
export const OPEN_SIGN_POPUP = 'OPEN_SIGN_POPUP';
export const REGISTERED_USER = 'REGISTERED_USER';
export const CLOSE_SIGN_POPUP = 'CLOSE_SIGN_POPUP';
export const GUEST_USER = 'GUEST_USER';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const AUTH_USER_FAILED = 'AUTH_USER_FAILED';
export const UPDATE_MEAL_PLAN = 'UPDATE_MEAL_PLAN';
export const UPDATE_GUEST_USER = 'UPDATE_GUEST_USER';
export const REMOVE_GUEST_USEER = 'REMOVE_GUEST_USEER';
export const STORE_INITIALIZE = 'STORE_INITIALIZE';

// -----------------------------------------------------------
// Socket for RTD Actions
// -----------------------------------------------------------

export const MENU_ITEM_AVAILABILITY = 'MENU_ITEM_AVAILABILITY';
export const MODIFIER_AVAILABILITY = 'MODIFIER_AVAILABILITY';
export const FORCED_MODIFIER_AVAILABILITY = 'FORCED_MODIFIER_AVAILABILITY';
export const RTD_INITIALIZE = 'RTD_INITIALIZE';



// WEBPACK FOOTER //
// ./src/redux/constants/actionTypes.js